import { render } from "./AdminBoxTreatmentPlan.vue?vue&type=template&id=495e4d84&scoped=true"
import script from "./AdminBoxTreatmentPlan.vue?vue&type=script&lang=js"
export * from "./AdminBoxTreatmentPlan.vue?vue&type=script&lang=js"

import "./AdminBoxTreatmentPlan.vue?vue&type=style&index=0&id=495e4d84&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495e4d84"]])

export default __exports__